/**
 * AUTO-GENERATED FILE.
 *
 * This file is updated by scripts/sync-teams-webinars.mjs.
 * Do not edit it manually unless you are seeding initial data.
 */

export type WebinarEventRecord = {
  id: string;
  title: string;
  startIsoUtc: string;
  endIsoUtc: string;
  registrationUrl: string;
  status: string;
};

export type WebinarFeed = {
  generatedAt: string;
  source: string;
  organizerLabel: string;
  displayTimeZone: string;
  webinars: WebinarEventRecord[];
};

const webinarFeed: WebinarFeed = {
  "generatedAt": "2026-11-04T02:01:33.262Z",
  "source": "microsoft-graph",
  "organizerLabel": "Outlook Insight Events",
  "displayTimeZone": "America/Los_Angeles",
  "webinars": []
};

export default webinarFeed;
